import { Component, inject, Signal } from '@angular/core';
import { LoadingAnimationComponent } from '../../feedback/loading-animation/loading-animation.component';
import { CustomTileSectionStore } from '../../../services/api/custom-tile-section/custom-tile-section-store.service';
import { EEntityType, ERelationType, ICustomTileSection } from '@web/dtos';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { NgStyle } from '@angular/common';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { ImageStore } from '../../../services/api/image/image-store.service';
import { AppendTestIdPipe } from '../../../pipes/append-test-id/append-test-id.pipe';
import { QuillViewComponent } from 'ngx-quill';

@Component({
  selector: 'custom-tiles',
  imports: [
    LoadingAnimationComponent,
    FilterTextsPipe,
    LanguagePipe,
    NgStyle,
    AppendTestIdPipe,
    QuillViewComponent,
  ],
  templateUrl: './custom-tiles.component.html',
  styles: '',
})
export class CustomTilesComponent {
  private readonly customTileSectionStore: CustomTileSectionStore = inject(
    CustomTileSectionStore
  );
  protected readonly corporateDesign: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly imageStore: ImageStore = inject(ImageStore);
  protected readonly isLoading: Signal<boolean> =
    this.customTileSectionStore.isLoading;
  protected readonly sections: Signal<ICustomTileSection[]> =
    this.customTileSectionStore.activeSections;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERelationType: typeof ERelationType = ERelationType;
}
